import React from 'react'
import cx from 'classnames'
import corestyles from '../core/styles.module.scss'
import styles from './QuizWithImage.module.scss'
import { Img } from 'components/basic/Img'
import FocusTrapWrapper from 'components/FocusTrapWrapper'
import { useClickOutsideModal } from 'hooks/useClickOutsideModal'

interface Props {
	pageWrapper: any
	handleClose: any
	emailCapModalVisible: any
	children: any
	mobileImg: string
	settings: any
	desktopImg: string
	blurred?: boolean
	fitbyHeight?: boolean
	overlayImage?: string
}

const ModalWrapper: React.FC<Props> = (props) => {
	const { pageWrapper, handleClose, emailCapModalVisible, children, settings } = props
	useClickOutsideModal(pageWrapper, handleClose, settings.isEULegacy || settings.isUK)
	const blurred = props.blurred ? styles.blurred : ''
	const fitbyHeight = props.fitbyHeight ? styles.fit_height : ''

	return (
		<FocusTrapWrapper active={emailCapModalVisible}>
			<div className={cx(corestyles.container, { [corestyles.none]: !emailCapModalVisible })}>
				<div
					className={cx(`${styles.content} ${styles.full_bleed}`, styles.mystery_ecap)}
					ref={pageWrapper}
				>
					<button
						type="button"
						role="button"
						aria-label="Close modal button"
						onClick={handleClose}
						className={`${styles.close_button}`}
					>
						<img
							aria-label={'Close'}
							src="https://eightsleep.imgix.net/close_d716c4c1-e156-409d-93c2-92907327e991.svg?v=1679385254"
							alt="Close popup icon"
						/>
					</button>
					<div className={cx(styles.image_wrapper, 'hideDesktop')}>
						<Img
							src={props.mobileImg}
							className={cx(styles.companion_img, blurred, fitbyHeight)}
							alt="Person happily in an Eight Sleep bed"
							lazy={false}
							dprHeight={1500}
							objectFit={'cover'}
							simple={true}
						/>
						<div className={`${styles.overlay}`}>{props.overlayImage && <img src={props.overlayImage} />}</div>
					</div>
					<div className={cx(corestyles.inner, styles.inner, 'tac-xs')}>
						<div className={styles.inner_text}>
							<img
								className={styles.logo}
								src="https://eightsleep.imgix.net/logo_0c17cdd4-7930-4520-b7a2-41331b22b2e2.svg?v=1619637907"
								alt="Eightsleep logo"
							/>
							{children}
						</div>
					</div>
					<div className={cx(styles.image_wrapper, 'hideMobile')}>
						<Img
							src={props.desktopImg}
							className={cx(styles.companion_img, blurred, fitbyHeight)}
							alt="Person happily in an Eight Sleep bed"
							lazy={false}
							objectFit={'cover'}
							dprHeight={1500}
							simple={true}
						/>
						<div className={`${styles.overlay}`}>{props.overlayImage && <img src={props.overlayImage} />}</div>
					</div>
				</div>
			</div>
		</FocusTrapWrapper>
	)
}

export default ModalWrapper
